module.exports = __webpack_public_path__ + "static/media/furLogo.46bb6c28.png";